<!--立即申请模块-->
<template>
  <div class="page-joinUs">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/family_banner.jpg">
      <ul class="content">
        <li @click.stop="showChange('1')" :class="{'active':tab=='1'}">
          <div class="title">
            <p>KRK工作和生活</p>
          </div>
        </li>
        <li @click.stop="showChange('2')" :class="{'active':tab=='2'}">
          <div class="title">
            <p>立刻申请 Careers</p>
          </div>
        </li>
        <!-- <li  @click.stop="showChange('3')" :class="{'active':tab=='3'}">
          <div class="title"><p>给家长的一封信</p></div>
        </li>-->
      </ul>
    </div>
    <div class="apply-page">
      <div class="header clearfix">
        <div class="header-left">
          <div class="hr"></div>
          <h2>立刻申请</h2>
          <h3>Apply Now</h3>
        </div>
        <div class="header-right">Apply Immediately</div>
      </div>
      <div class="jobs-container">
        <!-- <h2>招聘岗位</h2> -->
        <ul class="jobs-ul">
          <li class="job" v-for="(item,index) in jobs" :key="index" :class="{'active':item.isShow}">
            <p class="name" @click.stop="showJobs(item,$event)">{{item.name}}</p>
            <div class="job-detail">
              <h2 v-if="item.name=='English Lead Teacher'">Job Description</h2>
              <h2 v-else>职位描述</h2>
              <p v-if="item.name=='English Lead Teacher'">
                Overview
                <span></span>
              </p>
              <p v-else>
                基本信息
                <span></span>
              </p>
              <ul class="detail-ul">
                <li v-for="(list,i) in item.list" :key="i">
                  <div class="left">{{fieldMap[i]}}</div>
                  <div class="right" v-html="transformData(list)"></div>
                </li>
              </ul>
              <p v-if="item.name=='English Lead Teacher'">
                Responsibilities
                <span></span>
              </p>
              <p v-else>
                职责描述
                <span></span>
              </p>
              <ul class="detail-ul">
                <li v-for="(data,i) in item.data" :key="i">
                  <div class="right" v-html="transformData(data)"></div>
                </li>
              </ul>
              <p v-if="item.name=='English Lead Teacher'">
                Qualifications
                <span></span>
              </p>
              <p v-else>
                任职要求
                <span></span>
              </p>
              <ul class="detail-ul">
                <li v-for="(data2,i) in item.data2" :key="i">
                  <div class="right" v-html="transformData(data2)"></div>
                </li>
              </ul>
              <p v-if="item.name=='English Lead Teacher'">
                Compensation & Benefits
                <span></span>
              </p>
              <p v-if="item.name=='中方双语幼儿教师'">
                福利待遇
                <span></span>
              </p>
              <ul class="detail-ul">
                <li v-for="(data3,i) in item.data3" :key="i">
                  <div class="right" v-html="transformData(data3)"></div>
                </li>
              </ul>
              <p v-if="item.name=='English Lead Teacher'">
                Contact Information
                <span></span>
              </p>
              <p v-else>
                联系我们
                <span></span>
              </p>
              <p class="email" v-if="item.name=='English Lead Teacher'">
                Please send your resume to
                <i id="blue">jobs@kidsrkidschina.com</i>to apply.
              </p>
              <p class="email" v-else>
                请不要犹豫联系我们人力资源部：
                <i id="blue">recruit@kidsrkidschina.com</i>
              </p>
            </div>
          </li>
        </ul>
        <p class="memo">我们非常欢迎有志之士加入我们，与我们携手一起为中国的幼儿教育事业作出努力。</p>
      </div>
    </div>
    <!--工作和生活-->
    <Work v-show="tab=='1'"></Work>
    <!--立刻申请-->
    <!-- <Careers v-show="tab=='2'"></Careers> -->
    <!-- 给家长的一封信 -->
    <Letter v-show="tab=='3'"></Letter>
    <!--底部-->
    <v-footer></v-footer>
  </div>
</template>

<script>
import jobsData from "../../static/mock/jobs.json";
import Header from "@/components/header/Header"; //悬浮头部
import Work from "@/pages/join/work"; //工作和生活
// import Careers from '@/pages/careers'//立刻申请
import Letter from "@/pages/join/letter"; //给家长的一封信
import Footer from "@/components/footer/footer"; //底部模块
export default {
  data() {
    return {
      tab: "",
      jobs: [],
      fieldMap: {
        jbxx: "基本信息:",
        zwlx: "职位类型:",
        gzcs: "工作城市:",
        gzdd: "工作地点:",
        gzxz: "工作性质:",
        jy: "经验:",
        jyyq: "经验要求:",
        xl: "学历:",
        xlyq: "学历要求:",
        jnyq: "技能要求:",
        qtjn: "其他技能:",
        zzms: "职责描述:",
        rzyq: "任职要求:",
        position: "Position:",
        locations: "Locations:",
        time: "Time Type:",
        benefits: "benefits:"
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getJobs();
    });
    this.getTab();
  },
  components: {
    Header,
    Work,
    // Careers,
    Letter,
    "v-footer": Footer
  },
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/join") > -1) {
        this.getTab();
      }
    }
  },
  methods: {
    getJobs() {
      let param = {};
      jobsData.data.forEach(item => {
        this.jobs.push({
          name: item.name,
          list: item.list,
          //职责描述
          data: item.data,
          //任职要求
          data2: item.data2,
          //benefits
          data3: item.data3,
          isShow: false
        });
      });
    },
    showJobs(item, e) {
      let _this = this;
      let status = !item.isShow;
      this.jobs.forEach(job => {
        _this.$set(job, "isShow", false);
      });
      this.$set(item, "isShow", status);
    },
    transformData(data) {
      if (typeof data !== "string") return data;
      return data.replace(/\r\n/g, "<br/>");
    },
    getTab() {
      let route = this.$route.path;
      if (route.indexOf("/work") > -1) {
        this.tab = "1";
      } else if (route.indexOf("/careers") > -1) {
        this.tab = "2";
      } else if (route.indexOf("/letter") > -1) {
        this.tab = "3";
      }
    },
    showChange(val) {
      this.tab = val;
      switch (val) {
        case "1":
          this.$router.push({ name: "work" });
          break;
        case "2":
          this.$router.push({ name: "careers" });
          break;
        case "3":
          this.$router.push({ name: "letter" });
          break;
        default:
          break;
      }
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-joinUs {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        /* width:228px;
        height: 68px;*/
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          p {
            width: auto;
            height: 68px;
            padding: 0px 54px;
            font-size: 24px;
            font-family: PingFangSC-Regular;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
          }
        }
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
    }
  }
  .apply-page {
    width: 1200px;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    .header {
      width: 1200px;
      height: 155px;
      overflow: hidden;
      margin-top: 133px;
      margin-bottom: 70px;
      .header-left {
        float: left;
        .hr {
          width: 96px;
          height: 4px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          width: 236px;
          height: 96px;
          font-size: 48px;
          font-family: PingFangSC-Medium;
          color: rgba(51, 51, 51, 1);
          line-height: 96px;
        }
        h3 {
          width: 142px;
          height: 29px;
          line-height: 29px;
          background: rgba(174, 149, 79, 1);
          font-size: 24px;
          font-family: TimesNewRoman;
          font-weight: bold;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
        }
      }
      .header-right {
        float: left;
        margin-left: 330px;
        font-size: 80px;
        font-family: TimesNewRoman;
        font-style: italic;
        line-height: 122px;
        text-align: left;
        color: rgba(204, 204, 204, 1);
      }
    }
    .jobs-container {
      h2 {
        margin: 97px auto 38px 0px;
        height: 23px;
        font-size: 24px;
        font-family: PingFang;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
      }
      ul.jobs-ul {
        width: 1200px;
        li.job {
          position: relative;
          width: 100%;
          margin-bottom: 25px;
        }
        li.job::after {
          content: "";
          width: 10px;
          height: 10px;
          -webkit-transform: rotate(45deg);
          transform: rotate(45deg);
          border-right: 2px solid #333;
          border-bottom: 2px solid #333;
          position: absolute;
          right: 30px;
          top: 20px;
          cursor: pointer;
        }
        li.job.active::after,
        li.job:hover::after {
          border-right: 2px solid #fff;
          border-bottom: 2px solid #fff;
          transform: rotate(-45deg);
        }
        li .name {
          box-sizing: border-box;
          width: 100%;
          height: 50px;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          line-height: 50px;
          background: rgba(243, 243, 243, 1);
          padding-left: 25px;
          cursor: pointer;
        }
        li.active .name,
        li .name:hover {
          color: rgba(255, 255, 255, 1);
          background: rgba(14, 64, 130, 1);
        }
        li div.job-detail {
          display: none;
          opacity: 0;
          padding-left: 26px;
          background: rgba(255, 255, 255, 1);
          transition: all 0.1s ease-in-out;
          h2 {
            height: 17px;
            font-size: 20px;
            line-height: 30px;
            font-family: PingFangSC-Semibold;
            color: rgba(51, 51, 51, 1);
            // border-left: 4px solid #e5c221;
            margin: 37px auto 29px 0px;
            padding-left: 8px;
            font-weight: 600;
          }
          p {
            width: 250px;
            height: 20px;
            font-size: 20px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 30px;
            margin-left: 30px;
            margin-bottom: 24px;
            span {
              width: 30px;
              height: 2px;
              background: rgba(229, 194, 33, 1);
              display: block;
              margin-top: 8px;
              margin-bottom: 14px;
            }
          }
          .email {
            width: 500px;
            height: 14px;
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(70, 70, 70, 1);
            line-height: 30px;
            margin-bottom: 60px;
            #blue {
              height: 14px;
              font-size: 14px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              color: #0e4082;
              line-height: 30px;
              margin: 0px;
              font-style: normal;
            }
          }
          ul.detail-ul {
            font-size: 14px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            color: rgba(70, 70, 70, 1);
            line-height: 28px;
            margin: 0px auto 60px 30px;
            li {
              .left {
                display: inline-block;
                width: auto;
                text-align: left;
              }
              .right {
                width: 1022px;
                display: inline-block;
                vertical-align: top;
              }
            }
          }
        }
        li.active div.job-detail {
          display: block;
          opacity: 1;
        }
      }
      .memo {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: rgba(70, 70, 70, 1);
        line-height: 30px;
        margin-top: 30px;
        margin-bottom: 48px;
        font-weight: 400;
      }
    }
  }
}
@media (max-width: 767px) {
  .page-joinUs {
    .apply-page {
      width: 100%;
      .header {
        width: 100%;
        overflow: hidden;
        margin-top: 35px;
        margin-bottom: 0;
        height: 100px;
        .header-left {
          width: 100%;
          box-sizing: border-box;
          padding-left: 7.1%;
          .hr {
            width: 56px;
            height: 3px;
          }
          h2 {
            width: 100%;
            height: 41px;
            font-size: 21px;
            font-weight: 500;
            color: #333333;
            line-height: 25px;
            font-family: PingFangSC-Medium;
            padding: 10px 0 8px;
            box-sizing: border-box;
          }
          h3 {
            width: 64px;
            height: 20px;
            font-size: 10px;
            font-family: TimesNewRomanPS-BoldItalicMT;
            font-weight: normal;
            line-height: 20px;
            background: rgba(174, 149, 79, 1);
            font-style: italic;
            color: rgba(255, 255, 255, 1);
            text-align: center;
            padding: 0 5px;
          }
        }
        .header-right {
          display: none;
        }
      }
      .jobs-container {
        ul.jobs-ul {
          width: 100%;
          box-sizing: border-box;
          padding: 0 7.3%;
          li div.job-detail {
            padding-left: 0;
            .email {
              width: 95%;
            }
            ul.detail-ul {
              li {
                display: flex;
                .left {
                  padding-right: 7px;
                }
                .right {
                  flex: 1;
                }
              }
            }
          }
        }
        .memo {
          width: 100%;
          box-sizing: border-box;
          padding: 0 7.3%;
          margin-bottom: 38px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/careers.vue